module.exports = __webpack_public_path__ + "img/info-txt.5ddda444.png";